import gql from 'graphql-tag'

const ORTHOPHOTO_RESPONSE_FIELDS = gql`
  fragment OrthophotoResponseFields on OrthophotoResponse {
    orthophotoId
    companyId
    label
    sourceType
    sourcePlatform
    sourceUrl
    bounds
    status
    sourceSize
    resultSize
    autoZoom
    createdAt
    createdBy
    updatedAt
    updatedBy
    deletedAt
    deletedBy
    creator {
      fullname
    }
    editor {
      fullname
    }
    orthophotoProcessHistory {
      orthophotoId
      status
      message
      startedAt
      finishedAt
    }
  }
`

export const GET_ORTHOPHOTOS = gql`
  query Orthophotos($filter: GetOrthophotosFilter) {
    orthophotos(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      orthophotos {
        data {
          autoZoom
          label
          createdAt
          updatedAt
          orthophotoId
          bounds
          status
          creator {
            fullname
          }
          layer
        }
        pagination {
          page
          show
          total
        }
        token
      }
    }
  }
`

export const CREATE_ORTHOPHOTO = gql`
  mutation CreateOrthophoto($input: CreateOrthophotoInput!) {
  createOrthophoto(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    createOrthophoto {
      orthophotoId
      token
    }
  }
}
`

export const UPDATE_ORTHOPHOTO = gql`
  mutation UpdateOrthophoto($input: UpdateOrthophotoInput!) {
    updateOrthophoto(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateOrthophoto {
        orthophotoId
      }
    }
  }
`

export const DELETE_ORTHOPHOTO = gql`
  mutation DeleteOrthophoto($input: DeleteOrthophotoInput!) {
  deleteOrthophoto(input: $input) {
    isSuccessful
    errorCode
    errorName
    message
    status
    deleteOrthophoto {
      orthophotoId
    }
  }
}
`

export const COMPLETE_ORTHOPHOTO = gql`
  mutation CompleteUploadOrthophoto($input: CompleteUploadOrthophotoInput!) {
    completeUploadOrthophoto(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      completeUploadOrthophoto {
        ...OrthophotoResponseFields
      }
    }
  }
  ${ORTHOPHOTO_RESPONSE_FIELDS}
`

export const CANCEL_ORTHOPHOTO = gql`
  mutation CancelUploadOrthophoto($input: CancelUploadOrthophotoInput!) {
    cancelUploadOrthophoto(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      cancelUploadOrthophoto {
        orthophotoId
        status
      }
    }
  }
`
